import React from 'react'
import { withQuestionContainer } from '../../containers/gamification';
import RectLoader from '../shared/RectLoader';
import CustomButton from '../shared/CustomButton';
import { t } from '../../../i18n'
import { ArrowLeftLG } from '../normalizer';
import { withRouter } from 'react-router-dom';

const QuizOption = ({ option, isSelected, isCorrect, done, onSelect }) => {
  const optionClass = [
    'question-card__option',
    isSelected && 'question-card__option--selected',
    done && 'question-card__option--disabled',
    done && isSelected && !!isCorrect && 'question-card__option--correct',
    done && isSelected && !isCorrect && 'question-card__option--wrong',
  ].filter(Boolean).join(' ')

  return (
    <label className={optionClass} onClick={done ? undefined : () => onSelect(option.id)}>
      <span className="question-card__option-radio">
        {isSelected && <span className="question-card__option-radio-fill" />}
      </span>
      <span className="question-card__option-label">{option.option_name}</span>
      {done && !!isCorrect && (
        <i className="fas fa-check question-card__option-icon question-card__option-icon--correct" />
      )}
      {done && isSelected && !isCorrect && (
        <i className="fas fa-times question-card__option-icon question-card__option-icon--wrong" />
      )}
    </label>
  )
}

const QuestionCard = (props) => {
  const {
    currentQuestion = {},
    total, done,
    selectedAnswerId,
    currentQuestionNumber,
    onNextQuestion,
    onPrevQuestion,
    onQuizSubmit,
    onQuizresponse,
    quiz,
    quizzes,
    match, 
    history
  } = props

  // Derive quiz name: done mode gets quiz from history container, active mode finds from quizzes array
  const quizId = match && match.params && match.params.id ? Number(match.params.id) : null
  const quizName = (done && quiz && quiz.name)
    ? quiz.name
    : ((quizzes || []).find(q => q.id === quizId) || {}).name || 'Quiz'

  const backTo = done ? '/quiz/history' : '/quiz'
  const first = currentQuestionNumber === 1
  const last = currentQuestionNumber === total
  const showPrimary = !(done && last)
  const progress = total ? Number(currentQuestionNumber / total) * 100 : 0

  return (
    <div className="question-card">
      <div  className="question-card__back">
      <CustomButton link large tight to={backTo}>
        <ArrowLeftLG />
        {t('gamification2026.quiz.back')}
      </CustomButton>
      </div>

      <h2 className="question-card__title">{quizName}</h2>

      <div className="question-card__question-container">

        <p className="question-card__progress-label">
          {t('gamification2026.quiz.question')} {currentQuestionNumber} {t('gamification2026.quiz.of')} {total}
        </p>

        <p className="question-card__question-text">{currentQuestion.question_text}</p>

        <div className="question-card__progress-bar">
          <div className="question-card__progress-bar-container">
            <RectLoader thin progress={progress} />
          </div>
        </div>

        <ul className="question-card__options">
          {currentQuestion.options.map(a => (
            <li key={a.id} className="question-card__options-item">
              <QuizOption
                option={a}
                isSelected={selectedAnswerId === a.id}
                isCorrect={a.is_answer}
                done={done}
                onSelect={onQuizresponse}
              />
            </li>
          ))}
        </ul>

      </div>

      <div className="question-card__navigation">
        {!first && (
          <CustomButton secondary className="question-card__nav-btn" onClick={onPrevQuestion}>
            {t('gamification2026.quiz.previous')}
          </CustomButton>
        )}
        {showPrimary ? (
          <CustomButton primary className="question-card__nav-btn question-card__nav-btn--next" onClick={last ? onQuizSubmit : onNextQuestion}>
            {last ? t('gamification2026.quiz.submit-quiz') : t('gamification2026.quiz.next')}
          </CustomButton>
        ) : (
          <CustomButton onClick={()=>{history.push('/quiz/history')}} className="question-card__nav-btn">
            Voltar
          </CustomButton>
        )}
      </div>
    </div>
  )
}

export default withQuestionContainer(withRouter(QuestionCard))

export {
  QuestionCard
}
